export const sections = [
  {
    id: 'clinicalBackground',
    title: 'Antecedentes clínicos',
  },
  {
    id: 'medication',
    title: 'Medicamentos em uso',
  },
  {
    id: 'surgicalHistory',
    title: 'Antecedentes cirúrgicos',
  },
  {
    id: 'allergies',
    title: 'Alergias',
  },
  {
    id: 'habits',
    title: 'Hábitos',
  },
  {
    id: 'familyBackground',
    title: 'Antecedentes familiares',
  },
];
